import { render } from "./FolderComponent.vue?vue&type=template&id=2d55f171"
import script from "./FolderComponent.vue?vue&type=script&lang=js"
export * from "./FolderComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__